import { Link } from "react-router-dom";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef } from "react";

const variants = {
    primary: "ember-btn px-5 py-3 rounded-md font-display tracking-[0.12em] uppercase text-sm",
    ghost: "ghost-ember px-5 py-3 rounded-md font-display tracking-[0.12em] uppercase text-sm",
};

export const EmberButton = forwardRef(function EmberButton(
    { variant = "primary", asChild, to, className = "", ...rest },
    ref
) {
    const cls = `${variants[variant]} ${className}`;
    if (to) {
        return <Link ref={ref} to={to} className={cls} {...rest} />;
    }
    if (asChild) {
        return <Slot ref={ref} className={cls} {...rest} />;
    }
    return <button ref={ref} className={cls} {...rest} />;
});

export default EmberButton;
